<template>
	<div class="games">

		<banner class="games__banner header--additive-padding container" :backgrounds="bannerBackgroundImage">
			<div class="center">Draw Games</div>
		</banner>

		<div class="panel">
			<div class="page-container">

				<div
					v-if="$root.globals.isMaintenanceMode"
					class="maintenance-mode"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
						<path fill="#FFF" d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm1.2 18h-2.4v-2.4h2.4V18Zm0-4.8h-2.4V6h2.4v7.2Z"/>
					</svg>
					<span>We’re sorry! Game demos are unavailable at the moment as our systems are undergoing maintenance.</span>
				</div>
				
				<div class="panel__title">
					<div class="grid grid--bottom grid--auto grid--spread-between">
						<div class="grid__item width-100">
							<h1 class="h3 heading--black" v-html="title"></h1>
							<h3 class="h4 fc-pal--grey" v-html="description"></h3>
						</div>
					</div>
				</div>
				
				<PopularDrawGameList :games="filteredGames" :activeGameId="activeGameId" :activeTab="activeTab" ref="popularDrawGameList">
					<template slot="empty-message">
						No games match your chosen filters. <span class="link--action link--colored clickable" @click="$refs.gameFilter.reset()">
								Clear Filters?
							</span>
					</template>
				</PopularDrawGameList>

				<div class="mt--40 panel__title">
					<div class="grid grid--bottom grid--auto grid--spread-between">
						<div class="grid__item width-100">
							<h1 class="h3 heading--black" v-html="frequencyTitle"></h1>
							<h3 class="h4 fc-pal--grey" v-html="frequencyDescription"></h3>
						</div>
					</div>
				</div>
				
				<FrequencyDrawGameList :frequencyGames="frequencyDrawGame" :activeGameId="activeGameId" :activeTab="activeTab" ref="frequencyDrawGameList">
					<template slot="empty-message">
						No games match your chosen filters. <span class="link--action link--colored clickable" @click="$refs.gameFilter.reset()">
								Clear Filters?
							</span>
					</template>
				</FrequencyDrawGameList>

				<div class="mt--40 panel__title">
					<div class="grid grid--bottom grid--auto grid--spread-between">
						<div class="grid__item width-100">
							<h1 class="h3 heading--black" v-html="enhancedFeaturesTitle"></h1>
							<h3 class="h4 fc-pal--grey" v-html="enhancedFeaturesDescription"></h3>
						</div>
					</div>
				</div>
				
				<EnhancedFeaturesList :enhancedFeatures="enhancedFeatureLists" :activeGameId="activeGameId" :activeTab="activeTab" ref="enhancedFeaturesList">
					<template slot="empty-message">
						No games match your chosen filters. <span class="link--action link--colored clickable" @click="$refs.gameFilter.reset()">
								Clear Filters?
							</span>
					</template>
				</EnhancedFeaturesList>
			</div>
		</div>

	</div>
</template>

<script>
import { forEach, map, filter, findIndex, cloneDeep, intersection, orderBy } from 'lodash';

import Btn from './atoms/Btn'
import Banner from './molecules/Banner'
import GameFilter from './organisms/GameFilter'
import PopularDrawGameList from './organisms/PopularDrawGameList.vue';
import FrequencyDrawGameList from './organisms/FrequencyDrawGameList.vue';
import EnhancedFeaturesList from './organisms/EnhancedFeaturesList.vue';

export default {
  name: 'DrawGames',
	components: {
		Btn,
		Banner,
		GameFilter,
        PopularDrawGameList,
		FrequencyDrawGameList,
		EnhancedFeaturesList
	},
  data () {
    return {
			heroData: null,
			frequencyData: null,
			enhancedFeaturesData: null,
			bannerBackgroundImage: {},
			filteredGames: [],
			frequencyDrawGame: [],
			enhancedFeatureLists: [],
			filterVisible: false,
			filterFTT: true,
			heroGame: null,
    }
  },
	props: {
		activeGameId: [Number, String],
		activeTab: String,
	},
	computed: {
		title: function() {
			if(this.heroData){
				return this.heroData.title;
			}
		},
		description: function()
		{
			if(this.heroData){
				return this.heroData.description;
			}
		},
		frequencyTitle: function() {
			if(this.frequencyData){
				return this.frequencyData.title;
			}
		},
		frequencyDescription: function()
		{
			if(this.frequencyData){
				return this.frequencyData.description;
			}
		},
		enhancedFeaturesTitle: function() {
			if(this.enhancedFeaturesData){
				return this.enhancedFeaturesData.title;
			}
		},
		enhancedFeaturesDescription: function()
		{
			if(this.enhancedFeaturesData){
				return this.enhancedFeaturesData.description;
			}
		},
		showFilter: function()
		{
			var self = this;
			return self.filterVisible || self.$mq === 'ltab' || self.$mq === 'desk' ? true : false;
		},
		autocompleteData: function()
		{
			var self = this;
			if(!self.$root.$data.games) { return []; }

			return map(self.$root.$data.games, function(o)
			{
				return {
					value: o.id,
					search: o.gameName + " " + o.gameDescription,
					label: o.gameName
				};
			});
		}
	},
	created: function () {
		var self = this;

		self.$root.$data.gamesPromise.then((games) => {

			self.filterGames();
			self.$root.$data.appLoading = false;

		}).catch((error) => {
			console.log(error);
		});

		this.drawGamesBackgroundImage();
		this.getPageContent();
		this.getFrequencyPageContent();
		this.getEnhancedFeaturesPageContent();
	},
	mounted: function()
	{
		var self = this;
		self.$root.$data.appLoading = false;
	},
	watch: {
		'$root.userSelectedRegionKey': function()
		{
			this.$root.appImmediateLoading = true;

			this.getPageContent()
			.then(success =>
			{
				this.$root.appImmediateLoading = false;
			});
			this.getFrequencyPageContent()
			.then(success =>
			{
				this.$root.appImmediateLoading = false;
			});
			this.getEnhancedFeaturesPageContent()
			.then(success =>
			{
				this.$root.appImmediateLoading = false;
			});
		}
	},
	methods: {

		getPageContent: function()
		{
			// Get Hero Data
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.getPopularDrawGamesPage(params).then((success) =>
			{
				this.heroData = success.data.content[0];
			})
			.catch((error) =>
			{
				console.log(error);
			});
		},

		getFrequencyPageContent: function()
		{
			// Get Hero Data
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.getHighFrequencyDrawGamesPage(params).then((success) =>
			{
				this.frequencyData = success.data.content[0];
			})
			.catch((error) =>
			{
				console.log(error);
			});
		},

		getEnhancedFeaturesPageContent: function()
		{
			// Get Hero Data
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.getEnhancedFeaturesPage(params).then((success) =>
			{
				this.enhancedFeaturesData = success.data.content[0];
			})
			.catch((error) =>
			{
				console.log(error);
			});
		},

		showGameDetail(game)
		{
			var self = this;
			self.$refs.gameList.setActiveGame(game, 1000);
			self.trackEvent([
				'banner-button-clicked',
				null,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);
		},

		filterGames(filters)
		{
			var self = this;
			var games = cloneDeep(self.$root.$data.popularDrawGames);

			self.filteredGames = games;
			var frequencyGames = cloneDeep(self.$root.$data.frequencyDrawGames);
			self.frequencyDrawGame = frequencyGames;

			var features = cloneDeep(self.$root.$data.enhancedFeatures);
			self.enhancedFeatureLists = features;

		},

		drawGamesBackgroundImage() {

			var self = this;

			self.bannerBackgroundImage = {  
				mob: require('@/assets/img/banners/Draw_Games_Banner_Mobile.jpg'),  
				ptab: require('@/assets/img/banners/Draw_Games_Banner_Mobile.jpg'),  
				ltab: require('@/assets/img/banners/Draw_Games_Banner_Desktop.jpg'),  
				desk: require('@/assets/img/banners/Draw_Games_Banner_Desktop.jpg')  
			};
		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".games";
	#{$c}
	{
		&__banner
		{
			min-height: 290px;
			@include media(not-phab) { min-height: 400px; }

			&.banner
			{
				@include extend(vertical-bottom);
				padding: {top: rem(40); bottom: rem(40); }
				@include media(not-phab) { padding: {top: rem(56); bottom: rem(56); } }
			}

			.banner__content
			{
				text-align: center;
			}

			&-btn
			{
				&[disabled]
				{
					background-color: palette(grey);
					opacity: 0.9;
				}
			}
		}

		&__filter-toggle
		{
			text-align: center;
			@include extend(bgc-pal--lightest-grey);
			padding: { top: rem(16); bottom: rem(16); }
			border-bottom: 1px solid palette('divider');
		}

		&__filter-wrap
		{
			border-bottom: 1px solid palette(lighter-grey);
			background-color: palette(white);

			@include media(phab)
			{
				position: absolute;
				width: 100%;
				border-bottom-color: palette('divider');
				box-shadow: 0 1px 2px rgba(0,0,0,0.2);
				z-index: 100;
				padding-top: rem(24);
				padding-bottom: rem(24);
			}
		}

		&__filter-close
		{
			text-align: center;
			margin-top: rem(30);
			margin-bottom: rem(16);
		}
	}
.width-100{
	width:100% !important;
}
	.maintenance-mode {
		display: flex;
		justify-content: start;
		align-items: center;
		margin-bottom: 3rem;
		background: #FF671D;
		color: white;
		font-weight: bold;
		padding: 1rem 1.5rem;
		border-radius: 4px;

		svg {
			margin-right: 0.75rem;
		}
	}
</style>
<style scoped>
	.container {
		background: #322e2e;
		position: relative;
	}

	.center {
		font-size: 2.0em;
		transform: scale(1.39, 1.5);
		width: auto;
		height: 100px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin: -135px 0 0 -100px;
	}
</style>



// WEBPACK FOOTER //
// src/components/DrawGames.vue